















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import debounce from "lodash.debounce";

import CommonLayerDrawer from './layerDrawer/commonLayerDrawer/commonLayerDrawer.vue';
import BoundingBox from './boundingBox/boundingBox.vue';
import LineController from './lineController/lineController.vue';
import CurveController from './curveController/curveController.vue';
import PolygonController from './polygonController/polygonController.vue';
import TrimBox from './trimBox/trimBox.vue';
import TextEditor from './textEditor/textEditor.vue';
import InlineTextEditor from './inlineTextEditor/inlineTextEditor.vue';
import SmartGuide from './smartGuide/smartGuide.vue';

// TODO document2
import { Design } from '@/model/document2/page/surface/design/design'

import * as def from '@/definitions'
import { Const } from '@/const'
import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { TextLayer } from '@/model/document2/page/surface/design/layer/textLayer';
import { PolygonLayer } from '@/model/document2/page/surface/design/layer/polygonLayer';
import { PlainTextLayer } from '@/model/document2/page/surface/design/layer/plainTextLayer';
import { SimpleTextLayer } from '@/model/document2/page/surface/design/layer/simpleTextLayer';
import { ImageLayer } from '@/model/document2/page/surface/design/layer/imageLayer';
import { RasterImageLayer } from "@/model/document2/page/surface/design/layer/rasterImageLayer";
import { VectorImageLayer } from "@/model/document2/page/surface/design/layer/vectorImageLayer";
import { Vector2 } from '@/utilityModels/vector2'
import { Rectangle } from '@/utilityModels/rectangle'
import { FontManager } from '@/model/fontManager/fontManager';
import { LineLayer } from '@/model/document2/page/surface/design/layer/lineLayer';
import { CurveLayer } from '@/model/document2/page/surface/design/layer/curveLayer';
import { TableLayer } from '@/model/document2/page/surface/design/layer/tableLayer';
import { ImageHelper } from '@/helper/imageHelper';
import { HtmlHelper } from '@/helper/htmlHelper';
import { Page } from '@/model/document2/page/page';
import { UnitHelper } from '@/helper/unitHelper';
import { MathHelper } from '@/helper/mathHelper';
import { StringHelper } from '@/helper/stringHelper';
import { UserAgentHelper } from '@/helper/userAgentHelper';
import { DebugHelper } from "@/helper/debugHelper";
import { NameHelper } from "@/helper/nameHelper";

function openImageFile(file: File, fn: (dataBase64: string, width: number, height: number) => void): void
{
    const reader = new FileReader();
    reader.addEventListener('load', () => {
        const srcBase64 = reader.result as string;
        const el = document.createElement('img') as HTMLImageElement;
        el.addEventListener('load', () => {
            fn(
                srcBase64,
                el.naturalWidth,
                el.naturalHeight,
            );
        });
        el.src = srcBase64;
    });
    reader.readAsDataURL(file);
}

const isElement = (x: any): x is Element =>
  x instanceof Element;

@Component({
  components: {
    CommonLayerDrawer,
    BoundingBox,
    LineController,
    CurveController,
    PolygonController,
    TrimBox,
    TextEditor,
    InlineTextEditor,
    SmartGuide
  },
})
export default class CanvasWindow extends Vue
{
    @Prop() private documentRotate! : number;
    @Prop() private design! : Design;
    @Prop() private page! : Page;
    @Prop() private isReverseSurface! : boolean;
    @Prop({default: 100}) private zoomScale! : number;
    @Watch('zoomScale')
    onZoomScaleChanged(val: number, oldVal: number)
    {
        this.adjustFrameSize();
        this.$nextTick(() => {
            this.adjustFramePosition()
            if(!this.isAutoZoom){
                this.zoomPositioning(val, oldVal);
                // this.pointUpdate();
            }else{
                this.autoZoomPositioning();
            }
        });

        this.updateScaleFromPixels();
    }
    @Prop({default: false}) private isAutoZoom! : boolean;
    @Watch('isAutoZoom')
    onIsAutoZoomChanged(val: boolean, oldVal: boolean)
    {
        if(val){
            this.autoResize();
            this.$nextTick(() => this.autoZoomPositioning());
        }else{
            var canvasWindow = this.$refs.canvasWindow as Element;
            this.scrollPosition = {left: canvasWindow.scrollLeft, top: canvasWindow.scrollTop};
        }
    }
    @Prop() private isRendering! : boolean;

    @Prop() private isSubControllerVisible! : boolean;

    @Prop() private paperInfoText! : string;
    @Prop() private isFontLoaded! : boolean;

    // CommonLayerDrawerに渡すためのgetter
    private get useSimpleText() { return this.$store.getters.applicationState.useSimpleText; }
    private get moveLayerMode() { return this.$store.getters.applicationState.moveLayerMode; }
    private get moveLayerId() { return this.$store.getters.applicationState.moveLayerId; }

    // canvas-window表示領域の基準サイズ。このサイズに収まるサイズが100%
    static readonly CANVAS_WINDOW_BASE_WIDTH = 1160;
    static readonly CANVAS_WINDOW_BASE_HEIGHT = 854;
    // 固定pxとなるウィンドウサイズ
    static readonly FIXED_PX_BASE_WIDTH = 900;
    static readonly FIXED_PX_BASE_HEIGHT = 640;

    // キャンバスのオフセットはキャンバスサイズの何倍にするか
    static readonly CANVAS_OFFSET_FACTOR = 4;

    // マウス移動時の動作
    static MOUSE_MOVING_MODE_NONE = "none";
    static MOUSE_MOVING_MODE_ROTATE = "rotate";
    static MOUSE_MOVING_MODE_MOVE = "move";
    static MOUSE_MOVING_MODE_MOVE_MULTI = "move_multi";
    static MOUSE_MOVING_MODE_RESIZE_FROM_TOP_LEFT = "resize_from_top_left";
    static MOUSE_MOVING_MODE_RESIZE_FROM_LEFT = "resize_from_left";
    static MOUSE_MOVING_MODE_RESIZE_FROM_BOTTOM_LEFT = "resize_from_bottom_left";
    static MOUSE_MOVING_MODE_RESIZE_FROM_BOTTOM = "resize_from_bottom";
    static MOUSE_MOVING_MODE_RESIZE_FROM_BOTTOM_RIGHT = "resize_from_bottom_right";
    static MOUSE_MOVING_MODE_RESIZE_FROM_RIGHT = "resize_from_right";
    static MOUSE_MOVING_MODE_RESIZE_FROM_TOP_RIGHT = "resize_from_top_right";
    static MOUSE_MOVING_MODE_RESIZE_FROM_TOP = "resize_from_top";
    static MOUSE_MOVING_MODE_CONTROL_LINE_START = "control_line_start";
    static MOUSE_MOVING_MODE_CONTROL_LINE_END = "control_line_end";
    static MOUSE_MOVING_MODE_CONTROL_CURVE = "control_curve";
    static MOUSE_MOVING_MODE_CONTROL_POLYGON = "control_polygon";
    static MOUSE_MOVING_MODE_SELECT_AREA = "select_area";
    mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_NONE;
    selectedCurveControlPointIndex = 0;
    selectedPolygonControlPointIndex = 0;

    // マウス座標
    mouseStartX = 0;
    mouseStartY = 0;
    mouseCurrentX = 0;
    mouseCurrentY = 0;

    // 移動・リサイズ前のレイヤー情報
    srcLayerX = 0;
    srcLayerY = 0;
    srcLayerWidth = 0;
    srcLayerHeight = 0;
    srcLayerRotate = 0;
    srcControlPointX = 0;
    srcControlPointY = 0;
    srcTrimX = 0;
    srcTrimY = 0;
    srcTrimWidth = 100;
    srcTrimHeight = 100;
    // 複数レイヤー移動前のレイヤー情報
    // レイヤーid と位置のマッピング
    srcMultiLayersPositionMap : { [ key : string ] : { x : number, y : number } } = {};

    // テキストの選択状態
    srcTextSelectedLineIndex = 0;
    srcTextSelectedCharacterIndex = 0;
    srcTextIsAfterSelected = false;
    isTextSelecting = false;

    // ズーム対象のstyle
    svgWrapperStyle = {width: "", height: "", left: "",   top: "",   transform: ""};
    isFirst = true;
    // 連続したズーム処理のタイムアウト関数
    scrollTimeout;
    // 連続ズーム値変更前のスクロール位置
    scrollPosition = {left: 0, top: 0};
    // 連続ズーム値変更前のズーム値
    scrollBeforeScale = 0;
    // ズーム値変更前のズーム値
    oldScroll = {left: 0, top: 0};

    handleMouseMove = debounce(this.onMouseMove, 10);

    mounted()
    {
        var canvasWindow = this.$refs.canvasWindow as Element;

        this.updateScaleFromPixels();
        this.autoResize();
        this.onLoad();

        window.addEventListener('resize', this.onResize);
        canvasWindow.addEventListener('scroll', () =>{
            if(this.svgWrapperStyle.left == "0"){
                this.oldScroll.left = canvasWindow.scrollLeft;
            }
            if(this.svgWrapperStyle.top == "0"){
                this.oldScroll.top = canvasWindow.scrollTop;
            }
            // if(!this.isAutoZoom){
            //     this.pointUpdate();
            // }
        });
    }

    destroyed()
    {
        // テキスト編集終了
        this.isTextInEdit = false;
        // 選択レイヤーのクリア
        this.$emit("doCommand", "changeCurrentLayer", { layer : null });
        // アンドゥリドゥマネージャの初期化
        this.$emit("doCommand", "initUndoRedo", null);
        window.removeEventListener("resize", this.onResize);
    }

    onLoad()
    {
        var canvasWindow = this.$refs.canvasWindow as Element;

        this.updateScaleFromPixels();
        this.adjustFrameSize();

        this.scrollPosition = {
            left: canvasWindow.scrollLeft,
            top: canvasWindow.scrollTop
        }
        this.scrollBeforeScale = this.zoomScale;
    }

    onResize()
    {
        this.updateScaleFromPixels();

        if(this.isAutoZoom)
        {
            this.autoResize();
        }
        this.$nextTick(() => {
            if(!this.isAutoZoom){
                this.zoomPositioning(this.zoomScale, this.zoomScale);
                this.autoZoomPositioning();
            }
        });
    }

    // svg全体の表示位置を修正する
    pointUpdate(){
        var canvasWindow = this.$refs.canvasWindow as Element;
        var svg = this.$refs.svg as Element;

        clearTimeout(this.scrollTimeout);

        this.scrollTimeout = setTimeout(() => {
            if(this.scrollBeforeScale == this.zoomScale){
                this.scrollPosition = {
                    left: canvasWindow.scrollLeft,
                    top: canvasWindow.scrollTop
                }
                return;
            }
            if(this.svgWrapperStyle.left == "0"){
                canvasWindow.scrollLeft = (this.scrollPosition.left + canvasWindow.clientWidth / 2) / this.scrollBeforeScale * this.zoomScale - canvasWindow.clientWidth / 2;
                this.scrollPosition.left = canvasWindow.scrollLeft;
            }else{
                this.scrollPosition.left = (svg.clientWidth - canvasWindow.clientWidth) / 2;
            }
            if(this.svgWrapperStyle.top == "0"){
                canvasWindow.scrollTop = (this.scrollPosition.top + canvasWindow.clientHeight / 2) / this.scrollBeforeScale * this.zoomScale - canvasWindow.clientHeight / 2;
                this.scrollPosition.top = canvasWindow.scrollTop;
            }else{
                this.scrollPosition.top = (svg.clientHeight - canvasWindow.clientHeight) / 2;
            }

            this.scrollBeforeScale = this.zoomScale;
        }, 200);

    }

    /**
     * Drag and Drop
     */

    private dragover(e: DragEvent)
    {
        // ドロップするElementを更新するブラウザがあるので妨害する
        e.preventDefault();
    }

    private drop(e: DragEvent)
    {
        // 通常はファイルを開くので妨害する
        e.preventDefault();

        // データをドロップしていない
        if (!e.dataTransfer) { return; }
        if (e.dataTransfer.types.length < 1) { return; }

        // ファイルのみ受け付ける
        // FFだけ独自のデータが含まれる
        // IEだけArray.prototype.includesが使えない
        let typeIsFile = false;
        for (let i = 0; i < e.dataTransfer.types.length; i++) {
            if (e.dataTransfer.types[i] === 'Files') {
                typeIsFile = true;
            }
        }
        if (!typeIsFile) { return; }

        const parent = this.design.layer;
        const file: File = e.dataTransfer.files[0];
        openImageFile(file, (data, w, h) =>
        {
            // SVG
            var isVectorImage = /^image\/svg/.test(file.type);
            // JPG PNG GIF
            var isRasterImage = /^image\/(jpeg|png|gif)/.test(file.type);
            if(isVectorImage || isRasterImage)
            {
                // 白色透明化する
                ImageHelper.createWhiteTransparentImage(data, (wt) =>
                {
                    // DesignEditorで画像読み込み処理する
                    this.onDoCommand("importImage", {image : data, imageWhiteTransparent : wt, width : w, height : h, isSvg : isVectorImage});
                });
            }
            // 画像以外は無視
        })
    }

    private onDoCommand(command : string, paramater : any)
    {
        this.$emit("doCommand", command, paramater);
    }

    private updateScaleFromPixels()
    {
        this.$nextTick(()=>
        {
            var svg = this.getSvgElement();
            if(svg != null)
            {
                var clientWidth = svg.clientWidth > 0 ? svg.clientWidth : svg.getBoundingClientRect().width;
                var clientHeight = svg.clientHeight > 0 ? svg.clientHeight : svg.getBoundingClientRect().height;
                this.scaleFromPixels = Math.max(this.viewWidth / clientWidth, this.viewHeight / clientHeight);
            }
        });
    }

    static readonly BOUNDING_BOX_CURSOR_WIDTH_PX = 12;
    static readonly BOUNDING_BOX_CURSOR_HEIGHT_PX = 12;
    static readonly TRIM_BOX_CURSOR_WIDTH_PX = 8;
    static readonly TRIM_BOX_CURSOR_HEIGHT_PX = 8;

    private get boundingBoxCursorSize()
    {
        var width = CanvasWindow.BOUNDING_BOX_CURSOR_WIDTH_PX * this.scaleFromPixels;
        var height = CanvasWindow.BOUNDING_BOX_CURSOR_HEIGHT_PX * this.scaleFromPixels;
        return { width : width, height : height };
    }

    private get trimBoxCursorSize()
    {
        var width = CanvasWindow.TRIM_BOX_CURSOR_WIDTH_PX * this.scaleFromPixels;
        var height = CanvasWindow.TRIM_BOX_CURSOR_HEIGHT_PX * this.scaleFromPixels;
        return { width : width, height : height };
    }

    // キャンバス画像をpng(base64)として取得する
    // 常に最大の塗り足し幅まで作成する
    public getCanvasImageAsPng(completion : (image : string) => void )
    {
        // キャンバスのg要素を取得
        var canvas = this.$refs.canvas;
        // タグを取得
        var canvasTag = HtmlHelper.convertElementToTag(canvas);
        // 取り出す範囲
        var bleedRect = this.getBleedRectRotated(Const.BLEED_SIZE_MAX);
        // svgタグを追加して、指定範囲を取り出す
        var svgTagHeader = "<svg viewBox='" + bleedRect.x + " " + bleedRect.y + " " + bleedRect.width + " " + bleedRect.height + "' xmlns='http://www.w3.org/2000/svg'>";
        var svgTag = svgTagHeader + canvasTag + "</svg>";
        // レイヤー表示部をpngとして返す。
        var svgImage = ImageHelper.convertSVGTagToBase64(svgTag);
        ImageHelper.convertSVGImageToPng(svgImage, bleedRect.width, bleedRect.height, this.design.rotate, completion);
        // 対応していないCSSがあるので、このコンバートは使用しない
        //ImageHelper.convertSVGTagToPng(svgTag, this.viewWidth, this.viewHeight, completion);
    }

    // viewBox幅
    private get viewWidth() : number
    {
        return this.canvasWidth * CanvasWindow.CANVAS_OFFSET_FACTOR;
    }

    // viewBox高さ
    private get viewHeight() : number
    {
        return this.canvasHeight * CanvasWindow.CANVAS_OFFSET_FACTOR;
    }

    // viewBox
    private get viewBox() : string
    {
        return "0 0 " + this.viewWidth + " " + this.viewHeight;
    }

    // Canvas幅 *基準
    private get canvasWidth() : number
    {
        return UnitHelper.convert(this.design.width, "mm", "px");
    }

    // Canvas高さ *基準
    private get canvasHeight() : number
    {
        return UnitHelper.convert(this.design.height, "mm", "px");
    }

    // CanvasX
    private get canvasX() : number
    {
        return (this.viewWidth - this.canvasWidth) / 2;
    }

    // CanvasY
    private get canvasY() : number
    {
        return (this.viewHeight - this.canvasHeight) / 2;
    }

    // CanvasRadius
    private get canvasRadiusX() : number
    {
        return this.page.getSurface(this.isReverseSurface).getFrameRadius(this.page.currentDesignPosition) * this.scale;
    }
    private get canvasRadiusY() : number
    {
        return this.page.getSurface(this.isReverseSurface).getFrameRadius(this.page.currentDesignPosition) * this.scale;
    }

    // 楕円として描画するか
    private get isEllipseFrame()
    {
        var radius = this.page.getSurface(this.isReverseSurface).getFrameRadius(this.page.currentDesignPosition);
        var rect = this.page.getSurface(this.isReverseSurface).getDesignRect(this.page.currentDesignPosition);

        return rect.width <= radius * 2 || rect.height <= radius * 2;
    }

    // 内側の円を描画するか
    private get isInnerCircleVisible()
    {
        return this.page.getSurface(this.isReverseSurface).getFrameInnerCircleRadius(this.page.currentDesignPosition) > 0;
    }

    private get canvasInnerCX()
    {
        return this.canvasX + this.canvasWidth / 2;
    }

    private get canvasInnerCY()
    {
        return this.canvasY + this.canvasHeight / 2;
    }

    private get canvasInnerR()
    {
        return this.page.getSurface(this.isReverseSurface).getFrameInnerCircleRadius(this.page.currentDesignPosition) * this.scale;
    }

    // frameImage
    private get frameImageSource() : string
    {
        return this.page.getSurface(this.isReverseSurface).getFrameImage(this.page.currentDesignPosition);
    }

    // frameImageは用紙全体のものなので、編集中のフレームにフォーカスする
    private get frameTransform() : string
    {
        var transform = "";

        // オフセット
        // まずキャンバス位置までオフセットして、回転角ごと適切な位置補正を加える
        var designRect = this.page.getSurface(this.isReverseSurface).getDesignRect(this.page.currentDesignPosition);
        var dx = 0;
        var dy = 0;
        if(this.design.rotate == 90)
        {
            dx = (designRect.y + designRect.height) * this.scale;
            dy = -designRect.x * this.scale;
        }
        else if(this.design.rotate == 180)
        {
            dx = (designRect.x + designRect.width) * this.scale;
            dy = (designRect.y + designRect.height) * this.scale;
        }
        else if(this.design.rotate == 270)
        {
            dx = -designRect.y * this.scale;
            dy = (designRect.x + designRect.width) * this.scale;
        }
        else
        {
            dx = -designRect.x * this.scale;
            dy = -designRect.y * this.scale;
        }
        var offsetX = this.canvasX + dx;
        var offsetY = this.canvasY + dy;
        transform += "translate(" + offsetX + " " + offsetY + "),";

        // キャンバス回転角で回転
        transform += "rotate(" + this.design.rotate + "),";

        dx = 0;
        dy = 0;
        let pageRotate = this.isReverseSurface ? 
            (-this.documentRotate + 360) % 360 : this.documentRotate;
        if(pageRotate == 90)
        {
            dx = UnitHelper.convert(this.page.width, "mm", "px");
        }
        else if(pageRotate == 180)
        {
            dx = UnitHelper.convert(this.page.width, "mm", "px");
            dy = UnitHelper.convert(this.page.height, "mm", "px");
        }
        else if(pageRotate == 270)
        {
            dy = UnitHelper.convert(this.page.height, "mm", "px");
        }

        transform += "translate(" + dx + " " + dy + "),";

        // ドキュメント回転角で回転
        transform += "rotate(" + pageRotate + "),";

        // スケーリング
        // 拡大率は (イメージ幅 / デザイン幅) , (イメージ高さ / デザイン高さ)
        var imageWidth = pageRotate == 90 || pageRotate == 270 ? this.page.height : this.page.width;
        var imageHeight = pageRotate == 90 || pageRotate == 270 ? this.page.width : this.page.height;
        var scaleX = imageWidth / this.design.width;
        var scaleY = imageHeight / this.design.height;
        transform += "scale(" + scaleX + " " + scaleY + ")";

        return transform;
    }

    private get frameClipRect() : Rectangle
    {
        // フレームクリップ領域
        var designRect = this.page.getSurface(this.isReverseSurface).getDesignRect(this.page.currentDesignPosition);
        var x = 0;
        var y = 0;
        var w = 0;
        var h = 0;
        // designRectは回転が考慮されているので、ドキュメント回転角によりクリップ範囲を変化させる
        let pageRotate = this.isReverseSurface ? 
            (-this.documentRotate + 360) % 360 : this.documentRotate;
        if(pageRotate == 90)
        {
            x = designRect.y / this.page.height;
            y = (this.page.width - designRect.x - designRect.width) / this.page.width;
            w = designRect.height / this.page.height;
            h = designRect.width / this.page.width;
        }
        else if(pageRotate == 180)
        {
            x = (this.page.width - designRect.x - designRect.width) / this.page.width;
            y = (this.page.height - designRect.y - designRect.height) / this.page.height;
            w = designRect.width / this.page.width;
            h = designRect.height / this.page.height;
        }
        else if(pageRotate == 270)
        {
            x = (this.page.height - designRect.y - designRect.height) / this.page.height;
            y = designRect.x / this.page.width;
            w = designRect.height / this.page.height;
            h = designRect.width / this.page.width;
        }
        else
        {
            x = designRect.x / this.page.width;
            y = designRect.y / this.page.height;
            w = designRect.width / this.page.width;
            h = designRect.height / this.page.height;
        }

        return new Rectangle(x, y, w, h);
    }

    // 塗り足しサイズ
    private getBleedSize()
    {
        return this.$store.getters.userConfig.bleedSize;
    }

    // 塗り足し枠を回転を考慮して取得する
    private getBleedRectRotated(bleedSize : number)
    {
        var bleedRect = this.page.getSurface(this.isReverseSurface).getBleedRect(this.page.currentDesignPosition, bleedSize);
        var designRect = this.page.getSurface(this.isReverseSurface).getDesignRect(this.page.currentDesignPosition);
        var x = 0;
        var y = 0;
        var w = 0;
        var h = 0;
        if(this.design.rotate == 90)
        {
            x = this.canvasX - (bleedRect.bottom - designRect.bottom) * this.scale;
            y = this.canvasY + (bleedRect.x - designRect.x) * this.scale;
            w = bleedRect.height * this.scale;
            h = bleedRect.width * this.scale;
        }
        else if(this.design.rotate == 180)
        {
            x = this.canvasX - (bleedRect.right - designRect.right) * this.scale;
            y = this.canvasY - (bleedRect.bottom - designRect.bottom) * this.scale;
            w = bleedRect.width * this.scale;
            h = bleedRect.height * this.scale;
        }
        else if(this.design.rotate == 270)
        {
            x = this.canvasX + (bleedRect.y - designRect.y) * this.scale;
            y = this.canvasY - (bleedRect.right - designRect.right) * this.scale;
            w = bleedRect.height * this.scale;
            h = bleedRect.width * this.scale;
        }
        else
        {
            x = this.canvasX + (bleedRect.x - designRect.x) * this.scale;
            y = this.canvasY + (bleedRect.y - designRect.y) * this.scale;
            w = bleedRect.width * this.scale;
            h = bleedRect.height * this.scale;
        }

        return new Rectangle(x, y , w, h);
    }

    // 塗り足し幅
    private get bleedWidth() : number
    {
        return this.getBleedRectRotated(this.getBleedSize()).width;
    }

    // 塗り足し高さ
    private get bleedHeight() : number
    {
        return this.getBleedRectRotated(this.getBleedSize()).height;
    }

    // 塗り足しX
    private get bleedX() : number
    {
        return this.getBleedRectRotated(this.getBleedSize()).x;
    }

    // 塗り足しY
    private get bleedY() : number
    {
        return this.getBleedRectRotated(this.getBleedSize()).y;
    }

    // Area Selector
    private get selectX()
    {
        // マウス座標 -> SVG座標
        var startX = this.toSVGPointFromClient(this.mouseStartX, this.mouseStartY).x;
        var currentX = this.toSVGPointFromClient(this.mouseCurrentX, this.mouseCurrentY).x;
        return Math.min(startX, currentX);
    }

    private get selectY()
    {
        // マウス座標 -> SVG座標
        var startY = this.toSVGPointFromClient(this.mouseStartX, this.mouseStartY).y;
        var currentY = this.toSVGPointFromClient(this.mouseCurrentX, this.mouseCurrentY).y ;
        return Math.min(startY, currentY);
    }

    private get selectWidth()
    {
        // マウス座標 -> SVG座標
        var startX = this.toSVGPointFromClient(this.mouseStartX, this.mouseStartY).x;
        var currentX = this.toSVGPointFromClient(this.mouseCurrentX, this.mouseCurrentY).x;
        return Math.abs(startX - currentX);
    }

    private get selectHeight()
    {
        // マウス座標 -> SVG座標
        var startY = this.toSVGPointFromClient(this.mouseStartX, this.mouseStartY).y;
        var currentY = this.toSVGPointFromClient(this.mouseCurrentX, this.mouseCurrentY).y;
        return Math.abs(startY - currentY);
    }

    public get allLayers() : Layer[]
    {
        return this.design.getAllLayers();
    }

    public get layer() : Layer
    {
        return this.design.layer;
    }

    public get currentLayer() : Layer | null
    {
        return this.design.currentLayer;
    }

    public get selectLayers()
    {
        return this.design.getSelectLayerWithoutGroup();
    }

    public getSelectLayerBorderPoints(layer : Layer)
    {
        var points = "";
        for(var i = 0; i < layer.getVertexes().length; ++i)
        {
            if(i > 0) { points += " "; }
            var ver = layer.getVertexes()[i];
            points += (ver.x * this.scale + this.canvasX) + "," + (ver.y * this.scale + this.canvasY);
        }
        return points;
    }

    public get scale() : number
    {
        return UnitHelper.convert(1, "mm", "px");
    }

    public scaleFromPixels : number = 0;

    private get scaleFromSvg() : number
    {
        if(this.scaleFromPixels > 0)
        {
            return 1 / this.scaleFromPixels;
        }
        else
        {
            return 1;
        }
    }

    private getSvgElement() : SVGSVGElement | null
    {
        if(this.$refs.svg == null) { return null; }
        return this.$refs.svg as SVGSVGElement;
    }

    // 選択レイヤー枠表示条件
    private get selectLayerBorderVisible()
    {
        if(this.design.selectLayers.length == 1 && this.design.selectLayers[0].layerType == "group")
        {
            // 選択レイヤーがただ一つで、かつグループレイヤーの場合は選択レイヤーを表示しない
            return false;
        }

        // グループを除いた全選択レイヤーが複数
        var allSelectedLayers = this.design.getSelectLayerWithoutGroup();
        return allSelectedLayers.length > 1;
    }

    // バウンディングボックスの表示条件
    private get boundingBoxVisible()
    {
        // 選択レイヤー枠が表示されている場合は表示しない
        if(this.selectLayerBorderVisible) { return false; }
        // グループを除いた全選択レイヤーが0のときは表示しない
        if(this.design.getSelectLayerWithoutGroup().length == 0) { return false; }
        var editMode = this.$store.getters.applicationState.editMode;
        return this.currentLayer != null && this.currentLayer.layerType != "line" && this.currentLayer.layerType != "curve" && editMode == 0;
    }

    // 直線レイヤーコントローラの表示条件
    private get lineControllerVisible()
    {
        return this.currentLayer != null && this.currentLayer.layerType == "line";
    }

    // 曲線レイヤーコントローラの表示条件
    private get curveControllerVisible()
    {
        return this.currentLayer != null && this.currentLayer.layerType == "curve";
    }

    // 多角形レイヤーコントローラの表示条件
    private get polygonControllerVisible()
    {
        var editMode = this.$store.getters.applicationState.editMode;
        return this.currentLayer != null && this.currentLayer.layerType == "polygon" && (editMode == 1 || editMode == 2 || editMode == 3);
    }

    // トリミングボックスの表示条件
    private get trimBoxVisible()
    {
        var editMode = this.$store.getters.applicationState.editMode;
        return this.currentLayer != null && (this.currentLayer.layerType == "rasterImage" || this.currentLayer.layerType == "vectorImage") && editMode == 4;
    }

    // スマートガイドの表示条件
    private get smartGuideVisible()
    {
        // 移動・拡大縮小中
        return this.$store.getters.applicationState.moveLayerMode != 0;
    }

    // エリア選択矩形の表示条件
    private get isSelectArea()
    {
        return this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_SELECT_AREA;
    }

    // eventHandler
    private onBoundingBoxCursorSelected(cursor : string)
    {
        // マウス移動時の動作変更
        if(cursor == "top_left") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_BOTTOM_RIGHT; }
        else if(cursor == "left") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_RIGHT; }
        else if(cursor == "bottom_left") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_TOP_RIGHT; }
        else if(cursor == "bottom") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_TOP; }
        else if(cursor == "bottom_right") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_TOP_LEFT; }
        else if(cursor == "right") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_LEFT; }
        else if(cursor == "top_right") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_BOTTOM_LEFT; }
        else if(cursor == "top") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_BOTTOM; }
        else if(cursor == "rotate") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_ROTATE; }
    }

    private onTrimBoxCursorSelected(cursor : string)
    {
        // マウス移動時の動作変更
        if(cursor == "top_left") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_BOTTOM_RIGHT; }
        else if(cursor == "left") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_RIGHT; }
        else if(cursor == "bottom_left") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_TOP_RIGHT; }
        else if(cursor == "bottom") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_TOP; }
        else if(cursor == "bottom_right") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_TOP_LEFT; }
        else if(cursor == "right") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_LEFT; }
        else if(cursor == "top_right") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_BOTTOM_LEFT; }
        else if(cursor == "top") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_BOTTOM; }
        else if(cursor == "rotate") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_ROTATE; }
    }

    private onBoundingBoxFrameSelected()
    {
        // マウス移動時の動作変更
        this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_MOVE;
    }

    private onSelectStartPoint()
    {
        this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_CONTROL_LINE_START;
    }

    private onSelectEndPoint()
    {
        this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_CONTROL_LINE_END;
    }

    private onSelectCurvePoint(index)
    {
        this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_CONTROL_CURVE;
        this.selectedCurveControlPointIndex = index;
    }

    private onSelectPolygonPoint(index)
    {
        this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_CONTROL_POLYGON;
        this.selectedPolygonControlPointIndex = index;
    }

    private onMouseDown(event : MouseEvent)
    {
        // この時点でコンテキストメニューを非表示にする
        this.onDoCommand("hideContextMenu", {});
        
        // マウス座標保持
        this.mouseStartX = event.clientX;
        this.mouseStartY = event.clientY;

        // 操作点変更操作を行ったか?
        var isChangedControlPoint = false;

        if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_NONE)
        {
            // カーソルが選ばれなかったとき

            // マウス座標をデザイン座標系に変換
            var xInDesign = this.toDesignPointFromClient(event.clientX, event.clientY).x;
            var yInDesign = this.toDesignPointFromClient(event.clientX, event.clientY).y;

            DebugHelper.trace(event.clientX)
            DebugHelper.trace(event.clientY)

            // マウス位置にあるレイヤーを調べ、最前面のレイヤーを返す
            var foundLayers = this.design.getLayersFromPosition(xInDesign, yInDesign);
            var targetLayer : Layer | null = foundLayers.length > 0 ? foundLayers[foundLayers.length - 1] : null;

            if (targetLayer && event.shiftKey) {
                if(this.isTextInEdit) {
                    // テキスト編集中だった場合はテキスト編集を確定する
                    this.fixMultiCommand();
                }
                this.isTextInEdit = false;
                if (this.design.selectLayers.includes(targetLayer)) {
                    this.$emit('doCommand', 'removeLayerSelection', { layer: targetLayer })
                }
                else {
                    this.$emit('doCommand', 'appendLayerSelection', { layer: targetLayer });
                }
                return;
            }

            // 選択レイヤーにターゲットレイヤーが含まれているか調べる(ただし選択レイヤーが複数の時)
            var isTargetSelected = false;
            var selectLayers = this.design.getSelectLayerWithoutGroup();
            if(this.design.getSelectLayerWithoutGroup().length > 1)
            {
                for(var i = 0; i < selectLayers.length; ++i)
                {
                    if(targetLayer == selectLayers[i])
                    {
                        isTargetSelected = true;
                        break;
                    }
                }
            }
            if(isTargetSelected)
            {
                // 選択レイヤーにターゲットレイヤーが含まれている

                // テキスト編集モードを解除
                if(this.isTextInEdit)
                {
                    // テキスト編集中だった場合はテキスト編集を確定する
                    this.fixMultiCommand();
                }
                this.isTextInEdit = false;

                // 複数レイヤー移動
                this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_MOVE_MULTI;

                // レイヤー情報保持
                for(var i = 0; i < selectLayers.length; ++i)
                {
                    var selectLayer = selectLayers[i];
                    this.srcMultiLayersPositionMap[selectLayer.id] = { x : selectLayer.x, y : selectLayer.y };
                }

                return;
            }

            if(this.currentLayer == targetLayer)
            {
                if(targetLayer != null)
                {
                    // 同一レイヤーがクリックされた
                    if(targetLayer instanceof TextLayer)
                    {
                        // ターゲットがテキストレイヤーの場合は、右クリックは判定しない
                        if(event.button != 2)
                        {
                            if(targetLayer instanceof SimpleTextLayer)
                            {
                                // シンプルテキストレイヤーはこのタイミングで選択情報の更新をする
                                var calc = targetLayer.calcPositionFromPoint(xInDesign, yInDesign, this.$store.getters.fontManager);
                                targetLayer.selectedLineIndex = calc.lineIndex;
                                targetLayer.selectedCharacterIndex = calc.characterIndex;
                                targetLayer.isAfterSelected = calc.isAfter;
                            }
                            // ターゲットがテキストレイヤーの場合は、編集モード
                            this.isTextInEdit = true;

                            if(targetLayer instanceof TextLayer)
                            {
                                // この時点でのテキスト選択位置を保持する
                                this.srcTextSelectedLineIndex = targetLayer.selectedLineIndex;
                                this.srcTextSelectedCharacterIndex = targetLayer.selectedCharacterIndex;
                                this.srcTextIsAfterSelected = targetLayer.isAfterSelected;
                                // テキスト選択中フラグ
                                this.isTextSelecting = true;
                            }
                        }
                    }
                    else if(targetLayer instanceof TableLayer)
                    {
                        // 表レイヤーの場合は、選択状態を更新する
                        targetLayer.currentRow = targetLayer.touchedRow;
                        targetLayer.currentColumn = targetLayer.touchedColumn;
                        // レイヤー移動
                        this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_MOVE;
                        // 移動モード
                        this.$store.getters.applicationState.moveLayerMode = 1;
                    }
                    else if(targetLayer instanceof CurveLayer && this.$store.getters.applicationState.curveEditMode == 2)
                    {
                        // ターゲットが曲線レイヤー、かつ追加モード
                        // 曲線に制御点を追加する
                        this.$emit("doCommand", "addControlPointToCurve", { layer : targetLayer, index : targetLayer.lastTouchedIndex + 1, x : xInDesign, y : yInDesign });
                        isChangedControlPoint = true;
                    }
                    else if(targetLayer instanceof PolygonLayer && this.$store.getters.applicationState.editMode == 2 && targetLayer.isTouchedOnLine)
                    {
                        // ターゲットが多角形レイヤー、かつ追加モードで辺の上にいる
                        // 多角形に制御点を追加する
                        var points = new Array();
                        for(var i = 0; i < targetLayer.getControlPointsNumber(); ++i)
                        {
                            var point = targetLayer.getRotatedControlPoint(i);
                            points.push(point);
                            if(i == targetLayer.lastTouchedLineStartIndex)
                            {
                                // ここに追加
                                points.push(new Vector2(xInDesign, yInDesign));
                            }
                        }

                        this.$emit("doCommand", "applyPolygonControlPoints", { layer : this.currentLayer, points : points });
                        isChangedControlPoint = true;
                    }
                    else
                    {
                        // レイヤー移動
                        this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_MOVE;
                        // 移動モード
                        this.$store.getters.applicationState.moveLayerMode = 1;
                    }
                }
            }
            else
            {
                // 別のレイヤーがクリックされた or レイヤーのカレントが外れた
                // テキスト編集モードを解除
                if(this.isTextInEdit)
                {
                    // テキスト編集中だった場合はテキスト編集を確定する
                    this.fixMultiCommand();
                }
                this.isTextInEdit = false;

                // カレントレイヤー変更コマンド呼び出し
                this.$emit("doCommand", "changeCurrentLayer", { layer : targetLayer });

                if(targetLayer instanceof TextLayer)
                {
                    if(targetLayer instanceof SimpleTextLayer)
                    {
                        // シンプルテキストレイヤーはこのタイミングで選択情報の更新をする
                        var calc = targetLayer.calcPositionFromPoint(xInDesign, yInDesign, this.$store.getters.fontManager);
                        targetLayer.selectedLineIndex = calc.lineIndex;
                        targetLayer.selectedCharacterIndex = calc.characterIndex;
                        targetLayer.isAfterSelected = calc.isAfter;
                    }

                    // ターゲットがテキストレイヤーの場合は、編集モード
                    this.isTextInEdit = true;

                    if(targetLayer instanceof TextLayer)
                    {
                        // この時点でのテキスト選択位置を保持する
                        this.srcTextSelectedLineIndex = targetLayer.selectedLineIndex;
                        this.srcTextSelectedCharacterIndex = targetLayer.selectedCharacterIndex;
                        this.srcTextIsAfterSelected = targetLayer.isAfterSelected;
                        // テキスト選択中フラグ
                        this.isTextSelecting = true;
                    }
                }
                else if(targetLayer instanceof TableLayer)
                {
                    // 表レイヤーの場合は、選択状態をクリアする
                    targetLayer.currentRow = -1;
                    targetLayer.currentColumn = -1;
                    // レイヤー移動
                    this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_MOVE;
                    // 移動モード
                    this.$store.getters.applicationState.moveLayerMode = 1;
                }
                else
                {
                    // レイヤー移動
                    this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_MOVE;
                    // 移動モード
                    this.$store.getters.applicationState.moveLayerMode = 1;
                }
            }
        }
        else
        {
            // カーソルが選ばれた

            // テキスト編集モードは外す。レイヤー拡大縮小がしづらくなるため
            if(this.isTextInEdit)
            {
                // テキスト編集中だった場合はテキスト編集を確定する
                this.fixMultiCommand();
            }
            this.isTextInEdit = false;

            if(this.currentLayer instanceof TableLayer)
            {
                // 表だった場合セルの選択状態をクリア
                this.currentLayer.currentRow = -1;
                this.currentLayer.currentColumn = -1;
            }
        }

        if(this.currentLayer != null)
        {
            // レイヤー情報保持
            this.srcLayerX = this.currentLayer.x;
            this.srcLayerY = this.currentLayer.y;
            this.srcLayerWidth = this.currentLayer.width;
            this.srcLayerHeight = this.currentLayer.height;
            this.srcLayerRotate = this.currentLayer.rotate;
            if(this.currentLayer instanceof ImageLayer)
            {
                this.srcTrimX = this.currentLayer.trimRectNormalized.x;
                this.srcTrimY = this.currentLayer.trimRectNormalized.y;
                this.srcTrimWidth = this.currentLayer.trimRectNormalized.width;
                this.srcTrimHeight = this.currentLayer.trimRectNormalized.height;
            }

            if(this.currentLayer instanceof CurveLayer && this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_CONTROL_CURVE)
            {
                // 曲線レイヤの制御点が選ばれた
                if(this.$store.getters.applicationState.curveEditMode == 3)
                {
                    // 制御点削除
                    if(this.currentLayer.getControlPointsNumber() > 2)
                    {
                        // 3点以上制御点がある場合は削除可能
                        this.$emit("doCommand", "removeControlPointFromCurve", { layer : this.currentLayer, index : this.selectedCurveControlPointIndex });
                        isChangedControlPoint = true;
                    }
                    // 制御点移動をキャンセル
                    this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_NONE;
                }
                else
                {
                    // 制御点移動のために情報保持
                    var controlPoint = this.currentLayer.getControlPoint(this.selectedCurveControlPointIndex);
                    this.srcControlPointX = controlPoint.x;
                    this.srcControlPointY = controlPoint.y;
                }
            }
            else if(this.currentLayer instanceof PolygonLayer && this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_CONTROL_POLYGON)
            {
                // 多角形レイヤの制御点が選ばれた
                if(this.$store.getters.applicationState.editMode == 3)
                {
                    // 制御点削除
                    if(this.currentLayer.getControlPointsNumber() > 3)
                    {
                        // 4点以上制御点がある場合は削除可能
                        // 新しい表示上の操作点を求める
                        var points = new Array();
                        for(var i = 0; i < this.currentLayer.getControlPointsNumber(); ++i)
                        {
                            if(i == this.selectedPolygonControlPointIndex) { continue; }
                            var p = this.currentLayer.getRotatedControlPoint(i);
                            points.push(p);
                        }
                        this.$emit("doCommand", "applyPolygonControlPoints", { layer : this.currentLayer, points : points });
                        isChangedControlPoint = true;
                    }
                    // 制御点移動をキャンセル
                    this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_NONE;
                }
                else
                {
                    // 制御点移動のために情報保持
                    var controlPoint = this.currentLayer.getRotatedControlPoint(this.selectedPolygonControlPointIndex);
                    this.srcControlPointX = controlPoint.x;
                    this.srcControlPointY = controlPoint.y;
                }
            }
        }
        else
        {
            // エリア選択モードに切り替え
            this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_SELECT_AREA;
        }

        if(this.isTextInEdit)
        {
            // フォーカス
            var editor = this.$refs.textEditor as TextEditor;
            if(editor != null) { editor.focus(); }
        }
        else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_NONE || this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_SELECT_AREA)
        {
            if(!isChangedControlPoint)
            {
                // モードなしorエリア選択モードのとき、選択レイヤーをクリアする
                // ただし、制御点の編集を行った場合はこの処理をしない。
                this.$emit("doCommand", "changeCurrentLayer", { layer : null });
            }
        }
    }

    private onMouseMove(event : MouseEvent)
    {
        // マウス座標取得
        this.mouseCurrentX = event.clientX;
        this.mouseCurrentY = event.clientY;
        if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_MOVE_MULTI)
        {
            var currentMouse = this.toDesignPointFromClient(event.clientX, event.clientY);
            var beforeMouse = this.toDesignPointFromClient(this.mouseStartX, this.mouseStartY);
            var deltaXInDesign = currentMouse.x - beforeMouse.x;
            var deltaYInDesign = currentMouse.y - beforeMouse.y;

            // 複数レイヤーの移動
            var selectLayers = this.design.getSelectLayerWithoutGroup();
            for(var i = 0; i < selectLayers.length; ++i)
            {
                var selectLayer = selectLayers[i];
                if(this.srcMultiLayersPositionMap[selectLayer.id])
                {
                    var newX = this.srcMultiLayersPositionMap[selectLayer.id].x + deltaXInDesign;
                    var newY = this.srcMultiLayersPositionMap[selectLayer.id].y + deltaYInDesign;
                    // 変形コマンド発行を継続で送る
                    this.$emit("doCommand", "transformLayer", { layer : selectLayer,
                        x : newX, y : newY, width : selectLayer.width, height : selectLayer.height,
                        rotate : selectLayer.rotate, isFinish : false });
                }
            }
        }
        else if(this.mouseMovingMode != CanvasWindow.MOUSE_MOVING_MODE_NONE && this.currentLayer != null)
        {
            var currentMouse = this.toDesignPointFromClient(event.clientX, event.clientY);
            var beforeMouse = this.toDesignPointFromClient(this.mouseStartX, this.mouseStartY);
            var deltaXInDesign = currentMouse.x - beforeMouse.x;
            var deltaYInDesign = currentMouse.y - beforeMouse.y;

            // トリミング対応
            if(this.trimBoxVisible)
            {
                // レイヤーの回転角を元にベクトルを分解
                var vector = new Vector2(deltaXInDesign, deltaYInDesign).getResolutionDegrees(this.currentLayer.rotate);
                if(!MathHelper.equals(this.currentLayer.width, 0) && !MathHelper.equals(this.currentLayer.height, 0))
                {
                    var dstTrimX = this.srcTrimX;
                    var dstTrimY = this.srcTrimY;
                    var dstTrimWidth = this.srcTrimWidth;
                    var dstTrimHeight = this.srcTrimHeight;

                    if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_TOP_LEFT)
                    {
                        // 左上固定
                        dstTrimWidth = this.srcTrimWidth + vector.x / this.currentLayer.width * 100;
                        dstTrimHeight = this.srcTrimHeight + vector.y / this.currentLayer.height * 100;
                    }
                    else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_LEFT)
                    {
                        // 左固定
                        dstTrimWidth = this.srcTrimWidth + vector.x / this.currentLayer.width * 100;
                    }
                    else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_BOTTOM_LEFT)
                    {
                        // 左下固定
                        dstTrimY = this.srcTrimY + vector.y / this.currentLayer.height * 100;
                        dstTrimWidth = this.srcTrimWidth + vector.x / this.currentLayer.width * 100;
                        dstTrimHeight = this.srcTrimHeight - vector.y / this.currentLayer.height * 100;
                    }
                    else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_BOTTOM)
                    {
                        // 下固定
                        dstTrimY = this.srcTrimY + vector.y / this.currentLayer.height * 100;
                        dstTrimHeight = this.srcTrimHeight - vector.y / this.currentLayer.height * 100;
                    }
                    else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_BOTTOM_RIGHT)
                    {
                        // 右下固定
                        dstTrimX = this.srcTrimX + vector.x / this.currentLayer.width * 100;
                        dstTrimY = this.srcTrimY + vector.y / this.currentLayer.height * 100;
                        dstTrimWidth = this.srcTrimWidth - vector.x / this.currentLayer.width * 100;
                        dstTrimHeight = this.srcTrimHeight - vector.y / this.currentLayer.height * 100;
                    }
                    else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_RIGHT)
                    {
                        // 右固定
                        dstTrimX = this.srcTrimX + vector.x / this.currentLayer.width * 100;
                        dstTrimWidth = this.srcTrimWidth - vector.x / this.currentLayer.width * 100;
                    }
                    else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_TOP_RIGHT)
                    {
                        // 右上固定
                        dstTrimX = this.srcTrimX + vector.x / this.currentLayer.width * 100;
                        dstTrimWidth = this.srcTrimWidth - vector.x / this.currentLayer.width * 100;
                        dstTrimHeight = this.srcTrimHeight + vector.y / this.currentLayer.height * 100;
                    }
                    else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_TOP)
                    {
                        // 上固定
                        dstTrimHeight = this.srcTrimHeight + vector.y / this.currentLayer.height * 100;
                    }

                    // 値補正
                    if(dstTrimWidth < 0)
                    {
                        dstTrimWidth *= -1;
                        dstTrimX -= dstTrimWidth;
                    }
                    if(dstTrimHeight < 0)
                    {
                        dstTrimHeight *= -1;
                        dstTrimY -= dstTrimHeight;
                    }
                    if(dstTrimX < 0)
                    {
                        dstTrimWidth += dstTrimX;
                        dstTrimX = 0;
                    }
                    if(dstTrimX + dstTrimWidth > 100)
                    {
                        dstTrimWidth -= dstTrimX + dstTrimWidth - 100;
                        dstTrimWidth = 100 - dstTrimX;
                    }
                    if(dstTrimY < 0)
                    {
                        dstTrimHeight += dstTrimY;
                        dstTrimY = 0;
                    }
                    if(dstTrimY + dstTrimHeight > 100)
                    {
                        dstTrimHeight -= dstTrimY + dstTrimHeight - 100;
                        dstTrimHeight = 100 - dstTrimY;
                    }

                    // トリミング
                    this.$emit("doCommand", "trimLayer", { layer : this.currentLayer,
                        x : dstTrimX, y : dstTrimY, width : dstTrimWidth, height : dstTrimHeight,
                        isFinish : false });
                }
                return;
            }

            if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_CONTROL_LINE_START)
            {
                // 直線レイヤーの始点変更
                var newX = this.srcLayerX + deltaXInDesign;
                var newY = this.srcLayerY + deltaYInDesign;
                this.$emit("doCommand", "changeLayerProperty", { layer : this.currentLayer, propertyName : "startX", value : newX, isFinish : false });
                this.$emit("doCommand", "changeLayerProperty", { layer : this.currentLayer, propertyName : "startY", value : newY, isFinish : false });
                return;
            }
            if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_CONTROL_LINE_END)
            {
                // 直線レイヤーの終点変更
                var newX = this.srcLayerX + this.srcLayerWidth + deltaXInDesign;
                var newY = this.srcLayerY + this.srcLayerHeight + deltaYInDesign;
                this.$emit("doCommand", "changeLayerProperty", { layer : this.currentLayer, propertyName : "endX", value : newX, isFinish : false });
                this.$emit("doCommand", "changeLayerProperty", { layer : this.currentLayer, propertyName : "endY", value : newY, isFinish : false });
                return;
            }
            if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_CONTROL_CURVE)
            {
                // 曲線レイヤーの制御点変更
                if(this.currentLayer instanceof CurveLayer)
                {
                    var newControlPointX = this.srcControlPointX + deltaXInDesign;
                    var newControlPointY = this.srcControlPointY + deltaYInDesign;
                    this.$emit("doCommand", "moveCurveControlPoint", { layer : this.currentLayer, index : this.selectedCurveControlPointIndex, x : newControlPointX, y : newControlPointY, isFinish : false });
                }
                return;
            }
            if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_CONTROL_POLYGON)
            {
                // 多角形レイヤーの制御点変更
                if(this.currentLayer instanceof PolygonLayer)
                {
                    // 移動ベクトルを回転する
                    var newControlPointX = this.srcControlPointX + deltaXInDesign;
                    var newControlPointY = this.srcControlPointY + deltaYInDesign;
                    // 新しい多角形の制御点は、(newControlPointX, newControlPointY), これ以外は同じ位置
                    var dstRotated : Array<Vector2> = new Array();
                    for(var i = 0; i < this.currentLayer.getControlPointsNumber(); ++i)
                    {
                        if(i == this.selectedPolygonControlPointIndex)
                        {
                            dstRotated.push(new Vector2(newControlPointX, newControlPointY));
                        }
                        else
                        {
                            dstRotated.push(this.currentLayer.getRotatedControlPoint(i));
                        }
                    }
                    this.$emit("doCommand", "applyPolygonControlPoints", { layer : this.currentLayer, points : dstRotated, isFinish : false, isOnce : false });
                }
                return;
            }

            // レイヤーの回転角を元にベクトルを分解
            var vector = new Vector2(deltaXInDesign, deltaYInDesign).getResolutionDegrees(this.currentLayer.rotate);

            // レイヤーの移動・リサイズ後の情報
            var dstX = this.srcLayerX;
            var dstY = this.srcLayerY;
            var dstWidth = this.srcLayerWidth;
            var dstHeight = this.srcLayerHeight;
            var dstRotate = this.srcLayerRotate;

            // 中心位置を保持するか
            var isKeepCenter = false;
            // 左上、左下、右下、右上位置を保持するか
            var isKeepVertex : boolean[] = [false, false, false, false];
            // 縦横比固定か
            var keepRatio = this.currentLayer["keepRatio"] != null && this.currentLayer["keepRatio"] == 0;
            // バーコードはmobile以外では縦横比固定しない
            if(this.currentLayer.layerType == "barcode") { keepRatio = false; }

            if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_TOP_LEFT)
            {
                // 左上固定 -> 幅・高さ可変
                isKeepVertex[0] = true;
                dstWidth = this.srcLayerWidth + vector.x;
                dstHeight = this.srcLayerHeight + vector.y;
            }
            else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_LEFT)
            {
                // 左固定 -> 幅可変
                isKeepVertex[0] = true;
                isKeepVertex[1] = true;
                dstWidth = this.srcLayerWidth + vector.x;
            }
            else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_BOTTOM_LEFT)
            {
                // 左下固定 -> 幅・高さ可変
                isKeepVertex[1] = true;
                dstWidth = this.srcLayerWidth + vector.x;
                dstHeight = this.srcLayerHeight - vector.y;
            }
            else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_BOTTOM)
            {
                // 下固定 -> 高さ可変
                isKeepVertex[1] = true;
                isKeepVertex[2] = true;
                dstHeight = this.srcLayerHeight - vector.y;
            }
            else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_BOTTOM_RIGHT)
            {
                // 右下固定 -> 幅、高さ可変
                isKeepVertex[2] = true;
                dstWidth = this.srcLayerWidth - vector.x;
                dstHeight = this.srcLayerHeight - vector.y;
            }
            else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_RIGHT)
            {
                // 右固定 -> 幅可変
                isKeepVertex[2] = true;
                isKeepVertex[3] = true;
                dstWidth = this.srcLayerWidth - vector.x;
            }
            else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_TOP_RIGHT)
            {
                // 右上固定 -> 幅、高さ可変
                isKeepVertex[3] = true;
                dstWidth = this.srcLayerWidth - vector.x;
                dstHeight = this.srcLayerHeight + vector.y;
            }
            else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_TOP)
            {
                // 上固定 -> 高さ可変
                isKeepVertex[3] = true;
                isKeepVertex[0] = true;
                dstHeight = this.srcLayerHeight + vector.y;
            }
            else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_ROTATE)
            {
                // 回転
                // 現在のマウス座標をdesign座標系に変換
                var xInDesign = this.toDesignPointFromClient(event.clientX, event.clientY).x;
                var yInDesign = this.toDesignPointFromClient(event.clientX, event.clientY).y;
                // レイヤーの中心座標との差
                var fromCenterX = xInDesign - this.currentLayer.centerX;
                var fromCenterY = yInDesign - this.currentLayer.centerY;
                // アークタンジェントを取る
                var atan = this.currentLayer.height >= 0 ? Math.atan2(fromCenterX, -fromCenterY) : Math.atan2(-fromCenterX, fromCenterY);
                // degreesに変換したものを回転角とする。
                dstRotate = atan * 180 / Math.PI;
                // 角度を -180 ~ 180 に収める
                while ( dstRotate < -180 ) { dstRotate += 360; }
                while ( dstRotate > 180 ) { dstRotate -= 360; }
                // x, yの値は回転後に中心がずれない位置に変更する。
                isKeepCenter = true;
            }
            else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_MOVE)
            {
                // 移動
                dstX = this.srcLayerX + deltaXInDesign;
                dstY = this.srcLayerY + deltaYInDesign;
            }

            // 縦横比固定処理
            var applyKeepRatio =
                (isKeepVertex[0] && !isKeepVertex[1] && !isKeepVertex[2] && !isKeepVertex[3]) ||
                (!isKeepVertex[0] && isKeepVertex[1] && !isKeepVertex[2] && !isKeepVertex[3]) ||
                (!isKeepVertex[0] && !isKeepVertex[1] && isKeepVertex[2] && !isKeepVertex[3]) ||
                (!isKeepVertex[0] && !isKeepVertex[1] && !isKeepVertex[2] && isKeepVertex[3]);
            if(keepRatio && applyKeepRatio)
            {
                var deltaWidth = dstWidth - this.currentLayer.width;
                var deltaHeight = dstHeight - this.currentLayer.height;
                if(deltaWidth * deltaWidth > deltaHeight * deltaHeight)
                {
                    dstWidth = dstHeight * this.srcLayerWidth / this.srcLayerHeight;
                }
                else
                {
                    dstHeight = dstWidth * this.srcLayerHeight / this.srcLayerWidth;
                }
            }

            // 回転前の中心座標を保持
            var srcCenterX = this.currentLayer.centerX;
            var srcCenterY = this.currentLayer.centerY;
            // 拡大縮小前の頂点座標を保持
            var vertexes = this.currentLayer.getVertexes();

            // 現在の値を保持
            var currentX = this.currentLayer.x;
            var currentY = this.currentLayer.y;
            var currentWidth = this.currentLayer.width;
            var currentHeihgt = this.currentLayer.height;
            var currentRotate = this.currentLayer.rotate;

            // レイヤーに一時的に適用
            this.currentLayer.width = dstWidth;
            this.currentLayer.height = dstHeight;
            this.currentLayer.rotate = dstRotate;
            this.currentLayer.x = dstX;
            this.currentLayer.y = dstY;

            if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_MOVE)
            {
                // 移動の場合はスナップ
                var snap = this.getSnapValueLayerToOtherLayers(this.mouseMovingMode);
                var oldX = this.currentLayer.x;
                var oldY = this.currentLayer.y;
                if(!(snap.dx == 0 && snap.dy == 0))
                {
                    this.currentLayer.x = oldX + snap.dx;
                    this.currentLayer.y = oldY + snap.dy;
                }
            }

            // 変形後の頂点を取得する
            var dstVertexes = this.currentLayer.getVertexes();

            for(var i = 0; i < vertexes.length; ++i)
            {
                if(isKeepVertex[i])
                {
                    // 頂点座標が一致するように移動
                    this.currentLayer.x += -dstVertexes[i].x + vertexes[i].x;
                    this.currentLayer.y += -dstVertexes[i].y + vertexes[i].y;
                    break;
                }
            }

            // 拡大・縮小のスナップ
            this.snapScaleToOtherLayers(this.mouseMovingMode, keepRatio && applyKeepRatio);

            if(isKeepCenter)
            {
                // 回転後の中心座標を取得する
                var dstCenterX = this.currentLayer.centerX;
                var dstCenterY = this.currentLayer.centerY;
                // 中心座標が回転前の値に戻るように移動
                this.currentLayer.x += -dstCenterX + srcCenterX;
                this.currentLayer.y += -dstCenterY + srcCenterY;
            }

            // この段階ので値を保持
            var newX = this.currentLayer.x;
            var newY = this.currentLayer.y;
            var newWidth = this.currentLayer.width;
            var newHeight = this.currentLayer.height;
            var newRotate = this.currentLayer.rotate;

            // 元に戻す
            this.currentLayer.width = currentWidth;
            this.currentLayer.height = currentHeihgt;
            this.currentLayer.rotate = currentRotate;
            this.currentLayer.x = currentX;
            this.currentLayer.y = currentY;

            // 変形コマンド発行を継続で送る
            this.$emit("doCommand", "transformLayer", { layer : this.currentLayer,
                x : newX, y : newY, width : newWidth, height : newHeight,
                rotate : newRotate, isFinish : false });

            // 拡大・縮小モード
            if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_ROTATE)
            {
                // 回転モード
                this.$store.getters.applicationState.moveLayerMode = 3;
            }
            else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_MOVE)
            {
                // 移動モード
                this.$store.getters.applicationState.moveLayerMode = 1;
            }
            else
            {
                // 拡大縮小モード
                this.$store.getters.applicationState.moveLayerMode = 2;
            }
        }
        else if(this.currentLayer instanceof TextLayer && this.isTextSelecting)
        {
            if(this.currentLayer instanceof SimpleTextLayer)
            {
                // シンプルテキストレイヤーはこのタイミングで選択情報の更新をする
                var currentMouse = this.toDesignPointFromClient(event.clientX, event.clientY);
                var calc = this.currentLayer.calcPositionFromPoint(currentMouse.x, currentMouse.y, this.$store.getters.fontManager);
                this.currentLayer.selectedLineIndex = calc.lineIndex;
                this.currentLayer.selectedCharacterIndex = calc.characterIndex;
                this.currentLayer.isAfterSelected = calc.isAfter;
            }
            // テキスト選択中であれば選択ポジションの変化をチェック
            var srcTextPosition = this.currentLayer.getPositionFromLineAndCharacterIndex(this.srcTextSelectedLineIndex, this.srcTextSelectedCharacterIndex, this.srcTextIsAfterSelected);
            var dstTextPosition = this.currentLayer.getPositionFromLineAndCharacterIndex(this.currentLayer.selectedLineIndex, this.currentLayer.selectedCharacterIndex, this.currentLayer.isAfterSelected);
            // この位置を範囲選択する
            var editor = this.$refs.inlineTextEditor as InlineTextEditor;
            editor.select(Math.min(srcTextPosition, dstTextPosition), Math.max(srcTextPosition, dstTextPosition));
        }
    }

    // 拡大・縮小をスナップする
    private snapScaleToOtherLayers(mouseMovingMode : string, isKeepRatio = false)
    {
        if(this.currentLayer == null) return;

        if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_LEFT ||
            this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_BOTTOM ||
            this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_RIGHT ||
            this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_TOP)
        {
            // 辺の移動 : 一番近い直線上にスナップ

            // 動かす辺のベクトル
            var vertexes = this.currentLayer.getVertexes();
            var vIdx = 0;
            if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_TOP) vIdx = 1;
            else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_LEFT) vIdx = 2;
            else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_BOTTOM) vIdx = 3;

            var vx = vertexes[(vIdx + 1) % 4].x - vertexes[vIdx].x;
            var vy = vertexes[(vIdx + 1) % 4].y - vertexes[vIdx].y;
            var px = vertexes[vIdx].x;
            var py = vertexes[vIdx].y;
            // 逆位置の座標も補正のために取得する
            var ix = vertexes[(vIdx + 2) % 4].x;
            var iy = vertexes[(vIdx + 2) % 4].y;

            var allLayers = this.design.getAllLayers(false);
            var distMin = 10000;
            var deltaX = 0;
            var deltaY = 0;
            for(var i = 0; i < allLayers.length; ++i)
            {
                var targetLayer = allLayers[i];
                if(targetLayer == this.currentLayer) continue;
                if(targetLayer.layerType == "line" || targetLayer.layerType == "curve") continue;

                var targetVertexes = targetLayer.getVertexes();
                for(var j = 0; j < 4; ++j)
                {
                    // ある辺のベクトルを求める
                    var idx0 = j;
                    var idx1 = (j + 1) % 4;
                    var targetVx = targetVertexes[idx1].x - targetVertexes[idx0].x;
                    var targetVy = targetVertexes[idx1].y - targetVertexes[idx0].y;
                    // 動かす辺のベクトルに対して平行か？
                    if(vx == 0 && targetVx == 0)
                    {
                        // Y軸平行のベクトル同士
                        // この辺との距離
                        var dist = Math.abs(targetVertexes[idx0].x - px);
                        if(dist < distMin)
                        {
                            distMin = dist;
                            deltaX = targetVertexes[idx0].x - px;
                            deltaY = 0;
                        }
                    }
                    else if(vy == 0 && targetVy == 0)
                    {
                        // X軸平行のベクトル同士
                        // この辺との距離
                        var dist = Math.abs(targetVertexes[idx0].y - py);
                        if(dist < distMin)
                        {
                            distMin = dist;
                            deltaX = 0;
                            deltaY = targetVertexes[idx0].y - py;
                        }
                    }
                }
            }

            // 1mm範囲ならスナップ
            distMin = Math.abs(distMin) < 1 ? distMin : 0;
            if(distMin > 0)
            {
                var deltaW = 0;
                var deltaH = 0;
                var rotate = (this.currentLayer.rotate + 360) % 360;
                if(rotate == 0)
                {
                    deltaW = vIdx == 2 ? deltaX : -deltaX;
                    deltaH = vIdx == 1 ? deltaY : -deltaY;
                }
                else if (rotate == 90)
                {
                    deltaW = vIdx == 2 ? deltaY : -deltaY;
                    deltaH = vIdx == 1 ? -deltaX : deltaX;
                }
                else if (rotate == 180)
                {
                    deltaW = vIdx == 2 ? -deltaX : deltaX;
                    deltaH = vIdx == 1 ? -deltaY : deltaY;
                }
                else if(rotate == 270)
                {
                    deltaW = vIdx == 2 ? -deltaY : deltaY;
                    deltaH = vIdx == 1 ? deltaX : -deltaX;
                }

                this.currentLayer.width += deltaW;
                this.currentLayer.height += deltaH;

                // 逆の端点の位置を補正
                vertexes = this.currentLayer.getVertexes();
                this.currentLayer.x += -vertexes[(vIdx + 2) % 4].x + ix;
                this.currentLayer.y += -vertexes[(vIdx + 2) % 4].y + iy;
            }
        }
        else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_TOP_LEFT ||
            this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_BOTTOM_LEFT ||
            this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_BOTTOM_RIGHT ||
            this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_TOP_RIGHT)
        {
            // 端点 : 各レイヤーのバウンディングボックス(の延長直線)上にスナップ

            // 動かす端点の座標を取得
            var vIdx = 0;
            if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_TOP_RIGHT) vIdx = 1;
            else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_TOP_LEFT) vIdx = 2;
            else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_BOTTOM_LEFT) vIdx = 3;
            var vertexes = this.currentLayer.getVertexes();
            var vertex = vertexes[vIdx];
            var dxMin = 10000;
            var dyMin = 10000;
            var allLayers = this.design.getAllLayers(false);
            for(var i = 0; i < allLayers.length; ++i)
            {
                var targetLayer = allLayers[i];
                if(targetLayer == this.currentLayer) continue;
                var targetBounds = targetLayer.getBoundingRect();
                if(Math.abs(targetBounds.x - vertex.x) < Math.abs(dxMin)) { dxMin = targetBounds.x - vertex.x; }
                if(Math.abs(targetBounds.x + targetBounds.width - vertex.x) < Math.abs(dxMin)) { dxMin = targetBounds.x + targetBounds.width - vertex.x; }
                if(Math.abs(targetBounds.y - vertex.y) < Math.abs(dyMin)) { dyMin = targetBounds.y - vertex.y; }
                if(Math.abs(targetBounds.y + targetBounds.height - vertex.y) < Math.abs(dyMin)) { dyMin = targetBounds.y + targetBounds.height - vertex.y; }
            }
            // 1mm範囲ならスナップ
            dxMin = Math.abs(dxMin) < 1 ? dxMin : 0;
            dyMin = Math.abs(dyMin) < 1 ? dyMin : 0;
            if(dxMin != 0 || dyMin != 0)
            {
                // 動かした端点を補正
                var deltaWH : Vector2 | null = null;
                if(vIdx == 0) deltaWH = (new Vector2(-dxMin, -dyMin)).getResolutionDegrees(this.currentLayer.rotate);
                else if(vIdx == 1) deltaWH = (new Vector2(-dxMin, dyMin)).getResolutionDegrees(-this.currentLayer.rotate);
                else if(vIdx == 2) deltaWH = (new Vector2(dxMin, dyMin)).getResolutionDegrees(this.currentLayer.rotate);
                else if(vIdx == 3) deltaWH = (new Vector2(dxMin, -dyMin)).getResolutionDegrees(-this.currentLayer.rotate);
                if(deltaWH != null)
                {
                    var deltaW = deltaWH.x;
                    var deltaH = deltaWH.y;
                    var oldW = this.currentLayer.width;
                    var oldH = this.currentLayer.height;

                    if(isKeepRatio && oldW != 0 && oldW != 0)
                    {
                        // 縦横比固定補正
                        if(Math.abs(deltaW) > Math.abs(deltaH)) deltaH = deltaW * oldH / oldW;
                        else deltaW = deltaH * oldW / oldH;
                    }

                    this.currentLayer.width += deltaW;
                    this.currentLayer.height += deltaH;

                    // 逆の端点の位置を補正
                    var invertIndex = (vIdx + 2) % 4;
                    var invertVertex = this.currentLayer.getVertexes()[invertIndex];
                    this.currentLayer.x += -invertVertex.x + vertexes[invertIndex].x;
                    this.currentLayer.y += -invertVertex.y + vertexes[invertIndex].y;
                }
            }
        }
    }

    // カレントレイヤーをほかのレイヤーにスナップする
    private getSnapValueLayerToOtherLayers(mouseMovingMode : string) : { dx : number, dy : number }
    {
        if(this.currentLayer == null) { return { dx : 0, dy : 0 }; }
        var bounds = this.currentLayer.getBoundingRect();
        var dxMin = 10000;
        var dyMin = 10000;
        var allLayers = this.design.getAllLayers(false);
        for(var i = 0; i < allLayers.length; ++i)
        {
            var targetLayer = allLayers[i];
            if(targetLayer == this.currentLayer) { continue; }
            var targetBounds = targetLayer.getBoundingRect();
            if(Math.abs(targetBounds.x - bounds.x) < Math.abs(dxMin)) { dxMin = targetBounds.x - bounds.x; }
            if(Math.abs(targetBounds.x + targetBounds.width - bounds.x) < Math.abs(dxMin)) { dxMin = targetBounds.x + targetBounds.width - bounds.x;}
            if(Math.abs(targetBounds.x - (bounds.x + bounds.width)) < Math.abs(dxMin)) { dxMin = targetBounds.x - (bounds.x + bounds.width); }
            if(Math.abs(targetBounds.x + targetBounds.width - (bounds.x + bounds.width)) < Math.abs(dxMin)) { dxMin = targetBounds.x + targetBounds.width - (bounds.x + bounds.width); }

            if(Math.abs(targetBounds.y - bounds.y) < Math.abs(dyMin)) { dyMin = targetBounds.y - bounds.y; }
            if(Math.abs(targetBounds.y + targetBounds.height - bounds.y) < Math.abs(dyMin)) { dyMin = targetBounds.y + targetBounds.height - bounds.y; }
            if(Math.abs(targetBounds.y - (bounds.y + bounds.height)) < Math.abs(dyMin)) { dyMin = targetBounds.y - (bounds.y + bounds.height); }
            if(Math.abs(targetBounds.y + targetBounds.height - (bounds.y + bounds.height)) < Math.abs(dyMin)) { dyMin = targetBounds.y + targetBounds.height - (bounds.y + bounds.height);}
            // 移動の場合センタリング
            if(mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_MOVE)
            {
                if(Math.abs(targetBounds.x + targetBounds.width / 2 - (bounds.x + bounds.width / 2)) < Math.abs(dxMin))
                {
                    dxMin = targetBounds.x + targetBounds.width / 2 - (bounds.x + bounds.width / 2);
                }
                if(Math.abs(targetBounds.y + targetBounds.height / 2 - (bounds.y + bounds.height / 2)) < Math.abs(dyMin))
                {
                    dyMin = targetBounds.y + targetBounds.height / 2 - (bounds.y + bounds.height / 2);
                }
            }
        }
        // 1mm範囲ならスナップ
        dxMin = Math.abs(dxMin) < 1 ? dxMin : 0;
        dyMin = Math.abs(dyMin) < 1 ? dyMin : 0;
        return { dx : dxMin, dy : dyMin };
    }

    private onMouseUp(event : MouseEvent)
    {
        if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_SELECT_AREA)
        {
            // 選択レイヤー状態取得
            var startX = this.toDesignPointFromClient(this.mouseStartX, this.mouseStartY).x;
            var startY = this.toDesignPointFromClient(this.mouseStartX, this.mouseStartY).y;
            var endX = this.toDesignPointFromClient(this.mouseCurrentX, this.mouseCurrentY).x;
            var endY = this.toDesignPointFromClient(this.mouseCurrentX, this.mouseCurrentY).y;
            var x = Math.min(startX, endX);
            var y = Math.min(startY, endY);
            var width = Math.abs(startX - endX);
            var height = Math.abs(startY - endY);
            var selectedLayers = this.design.getLayersRectContained(x, y, width, height);
            for(var i = selectedLayers.length - 1; i >= 0; --i)
            {
                this.design.addSelectLayer(selectedLayers[i]);
            }
        }
        else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_MOVE_MULTI)
        {
            // 複数レイヤー移動を確定
            this.fixMultiCommand();
            // 情報のクリア
            this.srcMultiLayersPositionMap = {};
        }
        else if(this.mouseMovingMode != CanvasWindow.MOUSE_MOVING_MODE_NONE && this.currentLayer != null)
        {
            // コマンド確定を送る
            this.fixMultiCommand();
        }

        // マウス移動時の動作変更
        this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_NONE;
        // テキスト選択中フラグオフ
        this.isTextSelecting = false;
        this.$store.getters.applicationState.moveLayerMode = 0;
    }

    private onContextMenu(event: MouseEvent)
    {
        // 右クリックのイベント
        event.preventDefault();
        // コンテキストメニュー表示
        let type = this.isTextInEdit ? "text" : "layer";
        this.onDoCommand("showContextMenu", { event: event, type: type });
    }

    // テキストが編集中か
    public get isTextInEdit() : boolean
    {
        if (this.currentLayer == null) { return false; }
        if (this.currentLayer instanceof TextLayer)
        {
            var textLayer = this.currentLayer as TextLayer;
            return textLayer.inEdit;
        }
        return false;
    }

    // テキスト編集中フラグ切り替え
    public set isTextInEdit(isTextInEdit : boolean)
    {
        var editor = this.$refs.inlineTextEditor as InlineTextEditor;

        DebugHelper.trace("isTextInEdit : " + isTextInEdit)
        if(isTextInEdit)
        {
            if (this.currentLayer == null) { return; }

            var text = "";
            if (this.currentLayer instanceof TextLayer)
            {
                var textLayer = this.currentLayer as TextLayer;

                // 選択ポジション取得
                var pos = textLayer.getPositionFromLineAndCharacterIndex(textLayer.selectedLineIndex, textLayer.selectedCharacterIndex, textLayer.isAfterSelected);

                textLayer.inEdit = true;

                // 文字設定
                text = textLayer.text;
                if(editor != null)
                {
                    editor.setText(text);
                    editor.focus(false, pos, pos);
                }
            }
        }
        else
        {
            // すべてのテキストレイヤーから編集フラグを落とす
            var allLayers = this.design.getAllLayers();
            for(var i = 0; i < allLayers.length; ++i)
            {
                if(allLayers[i] instanceof TextLayer)
                {
                    var textLayer = allLayers[i] as TextLayer;
                    textLayer.inEdit = false;
                }
            }

            if(editor != null)
            {
                editor.setText("");
                editor.unfocus();
            }
        }
    }

    private get isVerticalInEdit()
    {
        // テキストが縦書きかどうか
        var result = false;
        if(this.currentLayer != null)
        {
            if(this.currentLayer instanceof PlainTextLayer || this.currentLayer instanceof SimpleTextLayer)
            {
                result = this.currentLayer.textOrientation == 1;
            }
        }
        return result;
    }

    // テキストの編集が行われた
    private onChangeText(text : string)
    {
        if(this.currentLayer == null) { return; }

        if(this.currentLayer instanceof TextLayer)
        {
            this.$emit("doCommand", "changeText", { layer : this.currentLayer, text : text, isFinish : false });
        }
    }

    // テキスト編集が行われた
    private onChangeTextEditor(parameter)
    {
        if(this.currentLayer == null) { return; }

        var text = parameter.text;
        if(this.currentLayer instanceof TextLayer)
        {
            this.$emit("doCommand", "changeText", { layer : this.currentLayer, text : text, isFinish : false });
        }
    }

    // テキスト確定された
    private onFixTextEditor()
    {
        this.fixMultiCommand();
    }

    private onChangeSelectionEditor(parameter)
    {
        if(this.currentLayer == null) { return; }

        if(this.currentLayer instanceof TextLayer)
        {
            this.currentLayer.lastStartPosition = this.currentLayer.startPosition;
            this.currentLayer.lastEndPosition = this.currentLayer.endPosition;
            this.currentLayer.startPosition = parameter.start;
            this.currentLayer.endPosition = parameter.end;
        }
    }

    // マルチコマンドを確定する
    private fixMultiCommand()
    {
        this.$emit("doCommand", "fixMultiCommand", null);
    }

    // 画面上のクライアント座標 -> design座標
    private toDesignPointFromClient(x, y)
    {
        // クライアント座標 -> SVG座標
        var svgPoint = this.toSVGPointFromClient(x, y);
        // SVG座標 -> design座標
        return new Vector2((svgPoint.x - this.canvasX) / this.scale, (svgPoint.y - this.canvasY) / this.scale);
    }

    // クライアント座標　-> SVG座標
    private toSVGPointFromClient(x, y)
    {
        var svg = this.getSvgElement();
        if(svg == null) { return new Vector2(0, 0); }
        var point = svg.createSVGPoint();
        point.x = x;
        point.y = y;

        var m = svg.getScreenCTM();
        if(m == null) { return new Vector2(0, 0); }
        var p = point.matrixTransform(m.inverse());
        return new Vector2(p.x, p.y);
    }

    // 自動リサイズする
    private autoResize()
    {
        // サイズの調整
        var wScale = (Math.max(window.innerWidth, CanvasWindow.FIXED_PX_BASE_WIDTH) - 280) / this.getCanvasWindowBaseWidth();
        var hScale = (Math.max(window.innerHeight, CanvasWindow.FIXED_PX_BASE_HEIGHT) -170) / this.getCanvasWindowBaseHeight();
        var zoomScale = Math.min(wScale, hScale) * 100 * 2.5;   // 2.5は目視による大きさ変更

        // 整数化
        zoomScale = Math.floor(zoomScale);
        if(zoomScale < Const.CANVAS_ZOOM_MIN) { zoomScale = Const.CANVAS_ZOOM_MIN; }
        if(zoomScale > Const.CANVAS_ZOOM_MAX) { zoomScale = Const.CANVAS_ZOOM_MAX; }
        this.onDoCommand("changeZoomScale", { scale : zoomScale });
    }

    // zoomを元にしてフレームのstyleを調整
    private adjustFrameSize()
    {
        this.svgWrapperStyle = {
            width: this.getCanvasWindowBaseWidth() * this.zoomScale / 100 + "px",
            height: this.getCanvasWindowBaseHeight() * this.zoomScale / 100 + "px",
            left: "0",   top: "0",   transform: "translate(0, 0)"
        };
    }

    // 拡大率100%のときのCanvasWindowの幅
    private getCanvasWindowBaseWidth()
    {
        // デザイン幅
        var designWidth = this.design.width;
        // mm -> pt
        var designWidthPt = UnitHelper.convert(designWidth, "mm", "pt");
        // この値がpxと一致するような幅
        var width = designWidthPt * CanvasWindow.CANVAS_OFFSET_FACTOR;
        return width;
    }

    // 拡大率100%のときのCanvasWindowの高さ
    private getCanvasWindowBaseHeight()
    {
        // デザイン高さ
        var designHeight = this.design.height;
        // mm -> pt
        var designHeightPt = UnitHelper.convert(designHeight, "mm", "pt");
        // この値がpxと一致するような幅
        var height = designHeightPt * CanvasWindow.CANVAS_OFFSET_FACTOR;
        return height;
    }

    // svg全体の表示位置調整
    private adjustFramePosition()
    {
        var canvasWindow = this.$refs.canvasWindow as Element;
        var svg = this.$refs.svg as HTMLElement;
        var canvasWidth = canvasWindow.clientWidth;
        if(canvasWidth == 0) { canvasWidth = canvasWindow.getBoundingClientRect().width; }
        var canvasHeight = canvasWindow.clientHeight;
        if(canvasHeight == 0) { canvasHeight = canvasWindow.getBoundingClientRect().height; }
        var svgWidth = svg.clientWidth;
        if(svgWidth == 0) { svgWidth = svg.getBoundingClientRect().width; }
        var svgHeight = svg.clientHeight;
        if(svgHeight == 0) { svgHeight = svg.getBoundingClientRect().height; }

        var width = this.getCanvasWindowBaseWidth() * this.zoomScale / 100;
        var height = this.getCanvasWindowBaseHeight() * this.zoomScale / 100;
        var left = "0";
        var top = "0";
        if(canvasWidth > svgWidth)
        {
            left = "calc(50% - " + (width / 2) + "px)";
        }
        if(canvasHeight > svgHeight)
        {
            top = "calc(50% - " + (height / 2) + "px)";
        }
        this.svgWrapperStyle = {
            width: width + "px",
            height: height + "px",
            left: left,
            top: top,
            transform: "translate(0, 0)"
        };
    }

    // zoom時のスクロール位置調整
    private zoomPositioning(val: number, oldVal: number){
        var canvasWindow = this.$refs.canvasWindow as Element;
        var svg = this.$refs.svg;


        if(!isElement(canvasWindow)) return;
        if(!isElement(svg)) return;

        if(this.isFirst){
            canvasWindow.scrollLeft = (svg.clientWidth - canvasWindow.clientWidth) / 2;
            canvasWindow.scrollTop = (svg.clientHeight - canvasWindow.clientHeight) / 2;
            this.scrollBeforeScale = val;

            this.oldScroll.left = canvasWindow.scrollLeft;
            this.oldScroll.top = canvasWindow.scrollTop;

            this.isFirst = false;
        }else if(val != oldVal){
            if(this.svgWrapperStyle.left == "0"){
                // 横スクロールが可能な時
                canvasWindow.scrollLeft = (this.oldScroll.left + canvasWindow.clientWidth / 2) / oldVal * val - canvasWindow.clientWidth / 2;
                this.oldScroll.left = canvasWindow.scrollLeft;
            }else{
                // 横スクロールが不可能な時
                this.oldScroll.left = (svg.clientWidth - canvasWindow.clientWidth) / 2;
            }
            if(this.svgWrapperStyle.top == "0"){
                // 縦スクロールが可能な時
                canvasWindow.scrollTop = (this.oldScroll.top + canvasWindow.clientHeight / 2) / oldVal * val - canvasWindow.clientHeight / 2;;
                this.oldScroll.top = canvasWindow.scrollTop;
            }else{
                // 縦スクロールが不可能な時
                this.oldScroll.top = (svg.clientHeight - canvasWindow.clientHeight) / 2;
            }
        }
    }
    // autoMode時のzoom位置調整
    private autoZoomPositioning(){
        var canvasWindow = this.$refs.canvasWindow as Element;
        var svg = this.$refs.svg;

        if(!isElement(canvasWindow)) return;
        if(!isElement(svg)) return;

        canvasWindow.scrollLeft = (this.svgClientWidth(svg) - canvasWindow.clientWidth) / 2;
        canvasWindow.scrollTop = (this.svgClientHeight(svg) - canvasWindow.clientHeight) / 2;
    }

    private svgClientWidth(svg: Element): number {
        return svg.clientWidth || svg.getBoundingClientRect().width
    }

    private svgClientHeight(svg: Element): number {
        return svg.clientHeight || svg.getBoundingClientRect().height
    }

    // 強制的にテキストの編集を開始する
    public forceStartEditText()
    {
        this.isTextInEdit = true;
    }

    // 外からテキストアップデート
    public updateText()
    {
        var editor = this.$refs.inlineTextEditor as InlineTextEditor;
        editor.update();
    }

    public pasteText(text : string)
    {
        var editor = this.$refs.inlineTextEditor as InlineTextEditor;
        editor.paste(text);
    }

    public deleteText()
    {
        var editor = this.$refs.inlineTextEditor as InlineTextEditor;
        editor.deleteSelection();
    }

    public selectAllText()
    {
        var editor = this.$refs.inlineTextEditor as InlineTextEditor;
        editor.selectAll(); 
    }

    public deselectText()
    {
        var editor = this.$refs.inlineTextEditor as InlineTextEditor;
        editor.deselect();
    }

    public canUndoText()
    {
        var editor = this.$refs.inlineTextEditor as InlineTextEditor;
        return editor.canUndo();
    }

    public undoText()
    {
        var editor = this.$refs.inlineTextEditor as InlineTextEditor;
        editor.undo();
    }

    public canRedoText()
    {
        var editor = this.$refs.inlineTextEditor as InlineTextEditor;
        return editor.canRedo();
    }

    public redoText()
    {
        var editor = this.$refs.inlineTextEditor as InlineTextEditor;
        editor.redo();
    }

    public isTextSelected()
    {
        var editor = this.$refs.inlineTextEditor as InlineTextEditor;
        return editor.isTextSelected();
    }

    // Utility
    // テキストサイズを測る
    public calcTextSize(str : string, fontSize : number, isBold : boolean = false, isItalic : boolean = false, isVertical : boolean = false)
    {
        var fontId = FontManager.DEFAULT_FONT_ID;
        var isHankaku = StringHelper.isHankaku(str);

        // fontSize -> pt
        var fontSizePt = UnitHelper.convert(fontSize / this.scale, "mm", "pt");
        var fontManager : FontManager = this.$store.getters.fontManager;
        var font = fontManager.getFontFamilyById(fontId);

        // fontFamily
        var fontFamily = fontManager.getFontFamilyName(fontId, isHankaku, false, isVertical);

        // weight
        var weight = "normal";
        if(font.weight == null)
        {
            // ウェイトがない場合はボールド設定を返す
            weight = isBold ? "bold" : "normal";
        }
        else
        {
            // ウェイトがある場合
            if(isBold)
            {
                weight = font.weight > 700 ? font.weight.toString() : "bold";
            }
            else
            {
                weight = font.weight.toString();
            }
        }

        // style
        var style = isItalic && fontManager.canItalic(fontId, isHankaku) ? "italic" : "normal";

        var ptSize = StringHelper.calcTextSizeOnSVGPt(str, fontSizePt, fontFamily, weight, style, isVertical);

        var width = UnitHelper.convert(ptSize.width, "pt", "mm") * this.scale;
        var height = UnitHelper.convert(ptSize.height, "pt", "mm") * this.scale;

        return { width : width, height : height };
    }

    overFlowVisible = false
    svgWrapperStyleBefore = {width: "", height: "", left: "",   top: "",   transform: ""};
    canvasWindowScrollLeftBefore = 0
    canvasWindowScrollTopBefore = 0

    fixCanvasArea(){
        var canvasWindow = this.$refs.canvasWindow as HTMLElement
        this.svgWrapperStyleBefore.left = this.svgWrapperStyle.left
        this.svgWrapperStyleBefore.top = this.svgWrapperStyle.top
        this.svgWrapperStyle.left = "-" + canvasWindow.scrollLeft
        this.svgWrapperStyle.top = "-" + canvasWindow.scrollTop
        this.canvasWindowScrollLeftBefore = canvasWindow.scrollLeft
        this.canvasWindowScrollTopBefore = canvasWindow.scrollTop

        this.overFlowVisible = true
    }

    unfixCanvasArea(){

        this.svgWrapperStyle.left = this.svgWrapperStyleBefore.left
        this.svgWrapperStyle.top = this.svgWrapperStyleBefore.top
        this.overFlowVisible = false

        this.$nextTick(()=>{
            var canvasWindow = this.$refs.canvasWindow as HTMLElement
            canvasWindow.scrollLeft = this.canvasWindowScrollLeftBefore
            canvasWindow.scrollTop = this.canvasWindowScrollTopBefore
        })

    }

    //----------上部の、用紙情報の部分----------//
    get paperInfoStyle(){
        if(this.isSubControllerVisible){
            return {
                width : "calc(100% - 280px - 320px)"
            }
        }else{
            return{
                width : "calc(100% - 280px)"
            }
        }
    }

    get selectedPaper(){
        return this.$store.getters.data.selectedPaper
    }
    //----------上部の、用紙情報の部分----------//

}
